var swiperThumbs = new Swiper(".product-gallery__thumbs", {
  loop: true,
  spaceBetween: 4,
  slidesPerView: 5,
  freeMode: true,
  watchSlidesProgress: true,

  breakpoints: {
    768: {
      spaceBetween: 8,
    },
  },
});
var swiperGallery = new Swiper(".product-gallery__main", {
  loop: true,
  spaceBetween: 10,

  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },

  navigation: {
    nextEl: ".swiper-next",
    prevEl: ".swiper-prev",
  },
  thumbs: {
    swiper: swiperThumbs,
  },
});
